<div class="container-fluid norge-application" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <app-norge-case-search></app-norge-case-search>

      @if (selectedCase) {
        <div class="card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <fa-icon [icon]="['fas', 'file-invoice']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
              {{ 'norge.soknad.rubrik' | translate }}
            </div>
          </div>

          <div class="card-body">
            <form [formGroup]="form" novalidate>

            <div class="form-section" formGroupName="arbeidsgiver">
              <div class="section-title">
                {{ 'norge.soknad.sektion.arbeidsgiver' | translate }}
              </div>
              <div class="form-grid">
                @if (control('arbeidsgiver.hvaErBoetsNavn').enabled) {
                  <div class="form-field form-field-span-2">
                    <label for="hvaErBoetsNavn">
                      {{ 'norge.soknad.felt.hvaErBoetsNavn' | translate }}
                    </label>
                    <input id="hvaErBoetsNavn" type="text" class="form-control" formControlName="hvaErBoetsNavn" readonly>
                    @if (fieldErrorKey(control('arbeidsgiver.hvaErBoetsNavn')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-section" formGroupName="personopplysninger">
              <div class="section-title">
                {{ 'norge.soknad.sektion.personopplysninger' | translate }}
              </div>
              <div class="form-grid">
                @if (control('personopplysninger.fornavnSoker').enabled) {
                  <div class="form-field">
                    <label for="fornavnSoker">
                      {{ 'norge.soknad.felt.fornavnSoker' | translate }}
                    </label>
                    <input id="fornavnSoker" type="text" class="form-control" formControlName="fornavnSoker">
                    @if (fieldErrorKey(control('personopplysninger.fornavnSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.etternavnSoker').enabled) {
                  <div class="form-field">
                    <label for="etternavnSoker">
                      {{ 'norge.soknad.felt.etternavnSoker' | translate }}
                    </label>
                    <input id="etternavnSoker" type="text" class="form-control" formControlName="etternavnSoker">
                    @if (fieldErrorKey(control('personopplysninger.etternavnSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('personopplysninger.harDuNorskFodselsnummerEllerDNummer').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuNorskFodselsnummerEllerDNummer' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuNorskFodselsnummerEllerDNummer-ja" value="ja" formControlName="harDuNorskFodselsnummerEllerDNummer">
                      <label class="form-check-label" for="harDuNorskFodselsnummerEllerDNummer-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuNorskFodselsnummerEllerDNummer-nei" value="nei" formControlName="harDuNorskFodselsnummerEllerDNummer">
                      <label class="form-check-label" for="harDuNorskFodselsnummerEllerDNummer-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('personopplysninger.harDuNorskFodselsnummerEllerDNummer')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('personopplysninger.fodselsnummerDNummerSoker').enabled) {
                  <div class="form-field">
                    <label for="fodselsnummerDNummerSoker">
                      {{ 'norge.soknad.felt.fodselsnummerDNummerSoker' | translate }}
                    </label>
                    <input id="fodselsnummerDNummerSoker" type="text" inputmode="numeric" class="form-control" formControlName="fodselsnummerDNummerSoker">
                    @if (fieldErrorKey(control('personopplysninger.fodselsnummerDNummerSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.fodselsdatoDdMmAaaaSoker').enabled) {
                  <div class="form-field">
                    <label for="fodselsdatoDdMmAaaaSoker">
                      {{ 'norge.soknad.felt.fodselsdatoDdMmAaaaSoker' | translate }}
                    </label>
                    <input id="fodselsdatoDdMmAaaaSoker" type="date" class="form-control" formControlName="fodselsdatoDdMmAaaaSoker">
                    @if (fieldErrorKey(control('personopplysninger.fodselsdatoDdMmAaaaSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('personopplysninger.borDuINorge').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.borDuINorge' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="borDuINorge-ja" value="ja" formControlName="borDuINorge">
                      <label class="form-check-label" for="borDuINorge-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="borDuINorge-nei" value="nei" formControlName="borDuINorge">
                      <label class="form-check-label" for="borDuINorge-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('personopplysninger.borDuINorge')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('personopplysninger.vegadresseEllerPostboksadresse').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.vegadresseEllerPostboksadresse' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="vegadresseEllerPostboksadresse-vegadresse" value="vegadresse" formControlName="vegadresseEllerPostboksadresse">
                      <label class="form-check-label" for="vegadresseEllerPostboksadresse-vegadresse">{{ 'norge.soknad.valg.vegadresse' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="vegadresseEllerPostboksadresse-postboksadresse" value="postboksadresse" formControlName="vegadresseEllerPostboksadresse">
                      <label class="form-check-label" for="vegadresseEllerPostboksadresse-postboksadresse">{{ 'norge.soknad.valg.postboksadresse' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('personopplysninger.vegadresseEllerPostboksadresse')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (addressVariant === 'vegadresse' || addressVariant === 'postboksadresse') {
                <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.kontaktadresse' | translate }}</div>
              }
              @if (addressVariant === 'utenlandsk') {
                <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.utenlandskKontaktadresse' | translate }}</div>
              }
              <div class="form-grid">
                @if (control('personopplysninger.coSoker').enabled) {
                  <div class="form-field">
                    <label for="coSoker">
                      {{ 'norge.soknad.felt.coSoker' | translate }}
                    </label>
                    <input id="coSoker" type="text" class="form-control" formControlName="coSoker">
                    @if (fieldErrorKey(control('personopplysninger.coSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.vegadresseSoker').enabled) {
                  <div class="form-field">
                    <label for="vegadresseSoker">
                      {{ 'norge.soknad.felt.vegadresseSoker' | translate }}
                    </label>
                    <input id="vegadresseSoker" type="text" class="form-control" formControlName="vegadresseSoker">
                    @if (fieldErrorKey(control('personopplysninger.vegadresseSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (addressVariant === 'postboksadresse') {
                  <div class="form-field">
                    <label for="postboksNrSokerNorsk">
                      {{ 'norge.soknad.felt.postboksNrSoker' | translate }}
                    </label>
                    <input id="postboksNrSokerNorsk" type="text" class="form-control" formControlName="postboksNrSoker">
                    @if (fieldErrorKey(control('personopplysninger.postboksNrSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (addressVariant === 'utenlandsk') {
                  <div class="form-field">
                    <label for="postboksNrSokerUtenlandsk">
                      {{ 'norge.soknad.felt.postboksNrSokerUtenlandsk' | translate }}
                    </label>
                    <input id="postboksNrSokerUtenlandsk" type="text" class="form-control" formControlName="postboksNrSoker">
                    @if (fieldErrorKey(control('personopplysninger.postboksNrSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.bygningSoker').enabled) {
                  <div class="form-field">
                    <label for="bygningSoker">
                      {{ 'norge.soknad.felt.bygningSoker' | translate }}
                    </label>
                    <input id="bygningSoker" type="text" class="form-control" formControlName="bygningSoker">
                    @if (fieldErrorKey(control('personopplysninger.bygningSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (addressVariant === 'vegadresse' || addressVariant === 'postboksadresse') {
                  <div class="form-field">
                    <label for="postnrSokerNorsk">
                      {{ 'norge.soknad.felt.postnrSoker' | translate }}
                    </label>
                    <input id="postnrSokerNorsk" type="text" inputmode="numeric" class="form-control" formControlName="postnrSoker">
                    @if (fieldErrorKey(control('personopplysninger.postnrSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (addressVariant === 'utenlandsk') {
                  <div class="form-field">
                    <label for="postnrSokerUtenlandsk">
                      {{ 'norge.soknad.felt.postnrSokerUtenlandsk' | translate }}
                    </label>
                    <input id="postnrSokerUtenlandsk" type="text" class="form-control" formControlName="postnrSoker">
                    @if (fieldErrorKey(control('personopplysninger.postnrSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (addressVariant === 'vegadresse' || addressVariant === 'postboksadresse') {
                  <div class="form-field">
                    <label for="poststedSokerNorsk">
                      {{ 'norge.soknad.felt.poststedSoker' | translate }}
                    </label>
                    <input id="poststedSokerNorsk" type="text" class="form-control" formControlName="poststedSoker">
                    @if (fieldErrorKey(control('personopplysninger.poststedSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (addressVariant === 'utenlandsk') {
                  <div class="form-field">
                    <label for="poststedSokerUtenlandsk">
                      {{ 'norge.soknad.felt.poststedSokerUtenlandsk' | translate }}
                    </label>
                    <input id="poststedSokerUtenlandsk" type="text" class="form-control" formControlName="poststedSoker">
                    @if (fieldErrorKey(control('personopplysninger.poststedSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.regionSoker').enabled) {
                  <div class="form-field">
                    <label for="regionSoker">
                      {{ 'norge.soknad.felt.regionSoker' | translate }}
                    </label>
                    <input id="regionSoker" type="text" class="form-control" formControlName="regionSoker">
                    @if (fieldErrorKey(control('personopplysninger.regionSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.landSoker').enabled) {
                  <div class="form-field country-field">
                    <label>
                      {{ 'label.country' | translate }}
                    </label>
                    <div class="country-combobox">
                      <button *ngIf="!isCountryDropdownOpen" type="button" class="form-control country-combobox__closed" (click)="openCountryDropdown()">
                        <span class="country-combobox__closed-value" *ngIf="selectedCountry as country">
                          <span [class]="getCountryFlagClass(country.code)" aria-hidden="true"></span>
                          <span class="country-dropdown__name">{{ country.name }}</span>
                        </span>
                        <span *ngIf="!selectedCountry">{{ 'placeholder.choose-country' | translate }}</span>
                      </button>
                      <input *ngIf="isCountryDropdownOpen" type="text" class="form-control country-combobox__input" [value]="countryFilterTerm" [placeholder]="'placeholder.choose-country' | translate" autocomplete="off" (input)="onCountrySearch($any($event.target).value)" (keydown)="onCountryKeydown($event)" (blur)="onCountryBlur()">
                      <div class="country-combobox__menu" *ngIf="isCountryDropdownOpen">
                        <button type="button" class="country-combobox__option" *ngFor="let country of filteredCountries; let countryIndex = index; trackBy: trackByCountryCode" [class.country-combobox__option--active]="countryIndex === activeCountryIndex" (mousedown)="$event.preventDefault()" (click)="selectCountry(country)">
                          <span [class]="getCountryFlagClass(country.code)" aria-hidden="true"></span>
                          <span class="country-dropdown__name">{{ country.name }}</span>
                        </button>
                        <div class="country-combobox__empty" *ngIf="filteredCountries.length === 0">
                          {{ 'label.inga-traffar' | translate }}
                        </div>
                      </div>
                    </div>
                    @if (fieldErrorKey(control('personopplysninger.landSoker')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              <div class="form-grid mt-3">
                @if (control('personopplysninger.ePostadresse').enabled) {
                  <div class="form-field">
                    <label for="ePostadresse">
                      {{ 'norge.soknad.felt.ePostadresse' | translate }}
                    </label>
                    <input id="ePostadresse" type="email" class="form-control" formControlName="ePostadresse">
                    @if (fieldErrorKey(control('personopplysninger.ePostadresse')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.telefonnummer').enabled) {
                  <div class="form-field">
                    <label for="telefonnummer">
                      {{ 'norge.soknad.felt.telefonnummer' | translate }}
                    </label>
                    <input id="telefonnummer" type="tel" class="form-control" formControlName="telefonnummer">
                    @if (fieldErrorKey(control('personopplysninger.telefonnummer')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('personopplysninger.harIkkeEPost').enabled) {
                <div class="form-check mt-2 mb-4">
                  <input class="form-check-input" type="checkbox" id="harIkkeEPost" formControlName="harIkkeEPost">
                  <label class="form-check-label" for="harIkkeEPost">
                    {{ 'norge.soknad.felt.harIkkeEPost' | translate }}
                  </label>
                </div>
              }
              <div class="form-grid">
                @if (control('personopplysninger.bostedskommune').enabled) {
                  <div class="form-field">
                    <label for="bostedskommune">
                      {{ 'norge.soknad.felt.bostedskommune' | translate }}
                    </label>
                    <input id="bostedskommune" type="text" class="form-control" formControlName="bostedskommune">
                    @if (fieldErrorKey(control('personopplysninger.bostedskommune')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('personopplysninger.harDuNorskEllerUtenlandskKonto').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuNorskEllerUtenlandskKonto' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuNorskEllerUtenlandskKonto-norsk" value="norsk" formControlName="harDuNorskEllerUtenlandskKonto">
                      <label class="form-check-label" for="harDuNorskEllerUtenlandskKonto-norsk">{{ 'norge.soknad.valg.norsk' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuNorskEllerUtenlandskKonto-utenlandsk" value="utenlandsk" formControlName="harDuNorskEllerUtenlandskKonto">
                      <label class="form-check-label" for="harDuNorskEllerUtenlandskKonto-utenlandsk">{{ 'norge.soknad.valg.utenlandsk' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('personopplysninger.harDuNorskEllerUtenlandskKonto')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('personopplysninger.kontoNummer').enabled) {
                  <div class="form-field">
                    <label for="kontoNummer">
                      {{ 'norge.soknad.felt.kontoNummer' | translate }}
                    </label>
                    <input id="kontoNummer" type="text" inputmode="numeric" class="form-control" formControlName="kontoNummer">
                    @if (fieldErrorKey(control('personopplysninger.kontoNummer')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.iban').enabled) {
                  <div class="form-field">
                    <label for="iban">
                      {{ 'norge.soknad.felt.iban' | translate }}
                    </label>
                    <input id="iban" type="text" class="form-control" formControlName="iban">
                    @if (fieldErrorKey(control('personopplysninger.iban')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('personopplysninger.swift').enabled) {
                  <div class="form-field">
                    <label for="swift">
                      {{ 'norge.soknad.felt.swift' | translate }}
                    </label>
                    <input id="swift" type="text" class="form-control" formControlName="swift">
                    @if (fieldErrorKey(control('personopplysninger.swift')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.skattetrekk' | translate }}</div>
              @if (control('personopplysninger.jegHarFrikort').enabled) {
                <div class="form-check mt-2 mb-4">
                  <input class="form-check-input" type="checkbox" id="jegHarFrikort" formControlName="jegHarFrikort">
                  <label class="form-check-label" for="jegHarFrikort">
                    {{ 'norge.soknad.felt.jegHarFrikort' | translate }}
                  </label>
                </div>
              }
              <div class="form-grid">
                @if (control('personopplysninger.oppgiProsenttrekketDitt').enabled) {
                  <div class="form-field">
                    <label for="oppgiProsenttrekketDitt">
                      {{ 'norge.soknad.felt.oppgiProsenttrekketDitt' | translate }}
    <app-field-help [tooltip]="'norge.soknad.hjelp.oppgiProsenttrekketDitt' | translate"></app-field-help>
                    </label>
                    <input id="oppgiProsenttrekketDitt" type="text" class="form-control" formControlName="oppgiProsenttrekketDitt">
                    @if (fieldErrorKey(control('personopplysninger.oppgiProsenttrekketDitt')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('personopplysninger.onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt-ja" value="ja" formControlName="onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt">
                      <label class="form-check-label" for="onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt-nei" value="nei" formControlName="onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt">
                      <label class="form-check-label" for="onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('personopplysninger.onskerDuITilleggAOpplyseOmHvilkenSkattetabellDuHarHatt')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('personopplysninger.oppgiDinSkattetabell').enabled) {
                  <div class="form-field">
                    <label for="oppgiDinSkattetabell">
                      {{ 'norge.soknad.felt.oppgiDinSkattetabell' | translate }}
                    </label>
                    <input id="oppgiDinSkattetabell" type="text" class="form-control" formControlName="oppgiDinSkattetabell">
                    @if (fieldErrorKey(control('personopplysninger.oppgiDinSkattetabell')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('personopplysninger.harDuAndrePliktigeTrekkITilleggTilSkattetrekk').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuAndrePliktigeTrekkITilleggTilSkattetrekk' | translate }}
    <app-field-help [tooltip]="'norge.soknad.hjelp.harDuAndrePliktigeTrekkITilleggTilSkattetrekk' | translate"></app-field-help>
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuAndrePliktigeTrekkITilleggTilSkattetrekk-ja" value="ja" formControlName="harDuAndrePliktigeTrekkITilleggTilSkattetrekk">
                      <label class="form-check-label" for="harDuAndrePliktigeTrekkITilleggTilSkattetrekk-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuAndrePliktigeTrekkITilleggTilSkattetrekk-nei" value="nei" formControlName="harDuAndrePliktigeTrekkITilleggTilSkattetrekk">
                      <label class="form-check-label" for="harDuAndrePliktigeTrekkITilleggTilSkattetrekk-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('personopplysninger.harDuAndrePliktigeTrekkITilleggTilSkattetrekk')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('personopplysninger.pliktigTrekkUtenomSkattetrekk').enabled) {
                <div formArrayName="pliktigTrekkUtenomSkattetrekk" class="mt-3">
                  @for (row of array('personopplysninger.pliktigTrekkUtenomSkattetrekk').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.pliktigTrekkUtenomSkattetrekk' | translate }} {{ rowIndex + 1 }}</div>
                        @if (array('personopplysninger.pliktigTrekkUtenomSkattetrekk').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('personopplysninger.pliktigTrekkUtenomSkattetrekk', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'pliktigTrekkUtenomSkattetrekk-typeTrekk-' + rowIndex">
                      {{ 'norge.soknad.felt.pliktigTrekkUtenomSkattetrekk.typeTrekk' | translate }}
                    </label>
                    <input [attr.id]="'pliktigTrekkUtenomSkattetrekk-typeTrekk-' + rowIndex" type="text" class="form-control" formControlName="typeTrekk">
                    @if (fieldErrorKey(row.get('typeTrekk')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'pliktigTrekkUtenomSkattetrekk-belop-' + rowIndex">
                      {{ 'norge.soknad.felt.pliktigTrekkUtenomSkattetrekk.belop' | translate }}
                    </label>
                    <app-decimal-input formControlName="belop"></app-decimal-input>
                    @if (fieldErrorKey(row.get('belop')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('personopplysninger.pliktigTrekkUtenomSkattetrekk')">{{ 'norge.soknad.knapper.pliktigTrekkUtenomSkattetrekk' | translate }}</button>
                </div>
              }
            </div>

            <div class="form-section" formGroupName="opplysningerOmArbeidsforhold">
              <div class="section-title">
                {{ 'norge.soknad.sektion.opplysningerOmArbeidsforhold' | translate }}
              </div>
              <div class="form-grid">
                @if (control('opplysningerOmArbeidsforhold.hvaVarStillingenDinIVirksomheten').enabled) {
                  <div class="form-field">
                    <label for="hvaVarStillingenDinIVirksomheten">
                      {{ 'norge.soknad.felt.hvaVarStillingenDinIVirksomheten' | translate }}
                    </label>
                    <input id="hvaVarStillingenDinIVirksomheten" type="text" class="form-control" formControlName="hvaVarStillingenDinIVirksomheten">
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.hvaVarStillingenDinIVirksomheten')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('opplysningerOmArbeidsforhold.fraHvilkenDatoBleDuAnsattDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="fraHvilkenDatoBleDuAnsattDdMmAaaa">
                      {{ 'norge.soknad.felt.fraHvilkenDatoBleDuAnsattDdMmAaaa' | translate }}
                    </label>
                    <input id="fraHvilkenDatoBleDuAnsattDdMmAaaa" type="date" class="form-control" formControlName="fraHvilkenDatoBleDuAnsattDdMmAaaa">
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.fraHvilkenDatoBleDuAnsattDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('opplysningerOmArbeidsforhold.hvilkenDatoMottokDuOppsigelsenDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="hvilkenDatoMottokDuOppsigelsenDdMmAaaa">
                      {{ 'norge.soknad.felt.hvilkenDatoMottokDuOppsigelsenDdMmAaaa' | translate }}
                    </label>
                    <input id="hvilkenDatoMottokDuOppsigelsenDdMmAaaa" type="date" class="form-control" formControlName="hvilkenDatoMottokDuOppsigelsenDdMmAaaa">
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.hvilkenDatoMottokDuOppsigelsenDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('opplysningerOmArbeidsforhold.oppgiLengdenPaOppsigelsestidenDin').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label for="oppgiLengdenPaOppsigelsestidenDin">
                    {{ 'norge.soknad.felt.oppgiLengdenPaOppsigelsestidenDin' | translate }}
                  </label>
                  <textarea id="oppgiLengdenPaOppsigelsestidenDin" rows="3" class="form-control" formControlName="oppgiLengdenPaOppsigelsestidenDin"></textarea>
                  @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.oppgiLengdenPaOppsigelsestidenDin')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('opplysningerOmArbeidsforhold.harDuTariffavtaleOmOppsigelsestid').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuTariffavtaleOmOppsigelsestid' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuTariffavtaleOmOppsigelsestid-ja" value="ja" formControlName="harDuTariffavtaleOmOppsigelsestid">
                      <label class="form-check-label" for="harDuTariffavtaleOmOppsigelsestid-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuTariffavtaleOmOppsigelsestid-nei" value="nei" formControlName="harDuTariffavtaleOmOppsigelsestid">
                      <label class="form-check-label" for="harDuTariffavtaleOmOppsigelsestid-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.harDuTariffavtaleOmOppsigelsestid')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('opplysningerOmArbeidsforhold.avtaltLonn').enabled) {
                  <div class="form-field">
                    <label for="avtaltLonn">
                      {{ 'norge.soknad.felt.avtaltLonn' | translate }}
    <app-field-help [tooltip]="'norge.soknad.hjelp.avtaltLonn' | translate"></app-field-help>
                    </label>
                    <app-decimal-input formControlName="avtaltLonn"></app-decimal-input>
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.avtaltLonn')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('opplysningerOmArbeidsforhold.avtaltLonnPer').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.avtaltLonnPer' | translate }}
                  </label>
                  <div class="d-flex flex-wrap gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="avtaltLonnPer-time" [checked]="isOptionChecked('opplysningerOmArbeidsforhold.avtaltLonnPer', 'time')" (change)="toggleOption('opplysningerOmArbeidsforhold.avtaltLonnPer', 'time')">
                      <label class="form-check-label" for="avtaltLonnPer-time">{{ 'norge.soknad.valg.time' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="avtaltLonnPer-uke" [checked]="isOptionChecked('opplysningerOmArbeidsforhold.avtaltLonnPer', 'uke')" (change)="toggleOption('opplysningerOmArbeidsforhold.avtaltLonnPer', 'uke')">
                      <label class="form-check-label" for="avtaltLonnPer-uke">{{ 'norge.soknad.valg.uke' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="avtaltLonnPer-maned" [checked]="isOptionChecked('opplysningerOmArbeidsforhold.avtaltLonnPer', 'maned')" (change)="toggleOption('opplysningerOmArbeidsforhold.avtaltLonnPer', 'maned')">
                      <label class="form-check-label" for="avtaltLonnPer-maned">{{ 'norge.soknad.valg.maned' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="avtaltLonnPer-akkordlonn" [checked]="isOptionChecked('opplysningerOmArbeidsforhold.avtaltLonnPer', 'akkordlonn')" (change)="toggleOption('opplysningerOmArbeidsforhold.avtaltLonnPer', 'akkordlonn')">
                      <label class="form-check-label" for="avtaltLonnPer-akkordlonn">{{ 'norge.soknad.valg.akkordlonn' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="avtaltLonnPer-provisjonEllerBonus" [checked]="isOptionChecked('opplysningerOmArbeidsforhold.avtaltLonnPer', 'provisjonEllerBonus')" (change)="toggleOption('opplysningerOmArbeidsforhold.avtaltLonnPer', 'provisjonEllerBonus')">
                      <label class="form-check-label" for="avtaltLonnPer-provisjonEllerBonus">{{ 'norge.soknad.valg.provisjonEllerBonus' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.avtaltLonnPer')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('opplysningerOmArbeidsforhold.avtaltAntallTimerPerUke').enabled) {
                  <div class="form-field">
                    <label for="avtaltAntallTimerPerUke">
                      {{ 'norge.soknad.felt.avtaltAntallTimerPerUke' | translate }}
                    </label>
                    <input id="avtaltAntallTimerPerUke" type="number" min="0" max="999999999999" step="1" class="form-control" formControlName="avtaltAntallTimerPerUke">
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.avtaltAntallTimerPerUke')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('opplysningerOmArbeidsforhold.redegjor').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label for="redegjor">
                    {{ 'norge.soknad.felt.redegjor' | translate }}
                  </label>
                  <textarea id="redegjor" rows="3" class="form-control" formControlName="redegjor"></textarea>
                  @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.redegjor')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('opplysningerOmArbeidsforhold.avtaltLonningsdato').enabled) {
                  <div class="form-field">
                    <label for="avtaltLonningsdato">
                      {{ 'norge.soknad.felt.avtaltLonningsdato' | translate }}
                    </label>
                    <input id="avtaltLonningsdato" type="text" class="form-control" formControlName="avtaltLonningsdato">
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.avtaltLonningsdato')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('opplysningerOmArbeidsforhold.harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt-ja" value="ja" formControlName="harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt">
                      <label class="form-check-label" for="harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt-nei" value="nei" formControlName="harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt">
                      <label class="form-check-label" for="harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.harDuMottattLonnFraArbeidsgiverenDinIPeriodenDuHarVaertAnsatt')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('opplysningerOmArbeidsforhold.mottattLonnFraOgMedDatoDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="mottattLonnFraOgMedDatoDdMmAaaa">
                      {{ 'norge.soknad.felt.mottattLonnFraOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input id="mottattLonnFraOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="mottattLonnFraOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.mottattLonnFraOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('opplysningerOmArbeidsforhold.mottattLonnTilOgMedDatoDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="mottattLonnTilOgMedDatoDdMmAaaa">
                      {{ 'norge.soknad.felt.mottattLonnTilOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input id="mottattLonnTilOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="mottattLonnTilOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.mottattLonnTilOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('opplysningerOmArbeidsforhold.harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning-ja" value="ja" formControlName="harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning">
                      <label class="form-check-label" for="harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning-nei" value="nei" formControlName="harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning">
                      <label class="form-check-label" for="harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.harDineLonnsEllerArbeidsvilkarBlittEndretITidenForKonkursapning')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('opplysningerOmArbeidsforhold.oppgiDatoForSisteEndringDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="oppgiDatoForSisteEndringDdMmAaaa">
                      {{ 'norge.soknad.felt.oppgiDatoForSisteEndringDdMmAaaa' | translate }}
                    </label>
                    <input id="oppgiDatoForSisteEndringDdMmAaaa" type="date" class="form-control" formControlName="oppgiDatoForSisteEndringDdMmAaaa">
                    @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.oppgiDatoForSisteEndringDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('opplysningerOmArbeidsforhold.hvaSlagsEndringHarDuHattILonnsEllerArbeidsvilkareneDine').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label for="hvaSlagsEndringHarDuHattILonnsEllerArbeidsvilkareneDine">
                    {{ 'norge.soknad.felt.hvaSlagsEndringHarDuHattILonnsEllerArbeidsvilkareneDine' | translate }}
                  </label>
                  <textarea id="hvaSlagsEndringHarDuHattILonnsEllerArbeidsvilkareneDine" rows="3" class="form-control" formControlName="hvaSlagsEndringHarDuHattILonnsEllerArbeidsvilkareneDine"></textarea>
                  @if (fieldErrorKey(control('opplysningerOmArbeidsforhold.hvaSlagsEndringHarDuHattILonnsEllerArbeidsvilkareneDine')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
            </div>

            <div class="form-section" formGroupName="feriepengerOgFerieavvikling">
              <div class="section-title">
                {{ 'norge.soknad.sektion.feriepengerOgFerieavvikling' | translate }}
              </div>
              @if (control('feriepengerOgFerieavvikling.harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor-ja" value="ja" formControlName="harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor">
                      <label class="form-check-label" for="harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor-nei" value="nei" formControlName="harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor">
                      <label class="form-check-label" for="harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('feriepengerOgFerieavvikling.harDuAvvikletFerieEllerKommerDuTilAAvvikleFerieIDenPeriodenDuSokerDekketLonnFor')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('feriepengerOgFerieavvikling.ferieperiodeR').enabled) {
                <div formArrayName="ferieperiodeR" class="mt-3">
                  @for (row of array('feriepengerOgFerieavvikling.ferieperiodeR').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.ferieperiodeR' | translate }} {{ rowIndex + 1 }}</div>
                        @if (array('feriepengerOgFerieavvikling.ferieperiodeR').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('feriepengerOgFerieavvikling.ferieperiodeR', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'ferieperiodeR-fraDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.ferieperiodeR.fraDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'ferieperiodeR-fraDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="fraDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('fraDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'ferieperiodeR-tilDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.ferieperiodeR.tilDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'ferieperiodeR-tilDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="tilDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('tilDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('feriepengerOgFerieavvikling.ferieperiodeR')">{{ 'norge.soknad.knapper.ferieperiodeR' | translate }}</button>
                </div>
              }
              @if (control('feriepengerOgFerieavvikling.harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2' | translate }}
    <app-field-help [tooltip]="'norge.soknad.hjelp.harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2' | translate"></app-field-help>
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2-ja" value="ja" formControlName="harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2">
                      <label class="form-check-label" for="harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2-nei" value="nei" formControlName="harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2">
                      <label class="form-check-label" for="harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('feriepengerOgFerieavvikling.harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('feriepengerOgFerieavvikling.harDuHoyereProsentsatsEnnDetSomFolgerAvFerieloven10Nr2').value === 'ja') {
                <div class="process-banner process-banner--warning mt-3">
                  <div class="process-banner__text">{{ 'norge.soknad.info.alertstripe1' | translate }}</div>
                </div>
              }
              <div class="form-grid">
                @if (control('feriepengerOgFerieavvikling.oppgiProsentsats').enabled) {
                  <div class="form-field">
                    <label for="oppgiProsentsats">
                      {{ 'norge.soknad.felt.oppgiProsentsats' | translate }}
                    </label>
                    <input id="oppgiProsentsats" type="number" min="0" max="100" step="any" class="form-control" formControlName="oppgiProsentsats">
                    @if (fieldErrorKey(control('feriepengerOgFerieavvikling.oppgiProsentsats')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('feriepengerOgFerieavvikling.hvorMangeFeriedagerHarDuAvvikletIAr').enabled) {
                  <div class="form-field">
                    <label for="hvorMangeFeriedagerHarDuAvvikletIAr">
                      {{ 'norge.soknad.felt.hvorMangeFeriedagerHarDuAvvikletIAr' | translate }}
                    </label>
                    <input id="hvorMangeFeriedagerHarDuAvvikletIAr" type="number" min="0" max="999999999999" step="1" class="form-control" formControlName="hvorMangeFeriedagerHarDuAvvikletIAr">
                    @if (fieldErrorKey(control('feriepengerOgFerieavvikling.hvorMangeFeriedagerHarDuAvvikletIAr')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('feriepengerOgFerieavvikling.harDuOverfortFeriedagerFraTidligereAr').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuOverfortFeriedagerFraTidligereAr' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuOverfortFeriedagerFraTidligereAr-ja" value="ja" formControlName="harDuOverfortFeriedagerFraTidligereAr">
                      <label class="form-check-label" for="harDuOverfortFeriedagerFraTidligereAr-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuOverfortFeriedagerFraTidligereAr-nei" value="nei" formControlName="harDuOverfortFeriedagerFraTidligereAr">
                      <label class="form-check-label" for="harDuOverfortFeriedagerFraTidligereAr-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('feriepengerOgFerieavvikling.harDuOverfortFeriedagerFraTidligereAr')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('feriepengerOgFerieavvikling.hvorMangeFeriedagerErOverfortFraTidligereAr').enabled) {
                  <div class="form-field">
                    <label for="hvorMangeFeriedagerErOverfortFraTidligereAr">
                      {{ 'norge.soknad.felt.hvorMangeFeriedagerErOverfortFraTidligereAr' | translate }}
                    </label>
                    <input id="hvorMangeFeriedagerErOverfortFraTidligereAr" type="number" min="0" max="999999999999" step="1" class="form-control" formControlName="hvorMangeFeriedagerErOverfortFraTidligereAr">
                    @if (fieldErrorKey(control('feriepengerOgFerieavvikling.hvorMangeFeriedagerErOverfortFraTidligereAr')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-section" formGroupName="eierandeler">
              <div class="section-title">
                {{ 'norge.soknad.sektion.eierandeler' | translate }}
              </div>
              <div class="process-banner process-banner--warning mt-3">
                <div class="process-banner__text">{{ 'norge.soknad.info.alertstripe2' | translate }}</div>
              </div>
              @if (control('eierandeler.harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden-ja" value="ja" formControlName="harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden">
                      <label class="form-check-label" for="harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden-nei" value="nei" formControlName="harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden">
                      <label class="form-check-label" for="harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('eierandeler.harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('eierandeler.harDuHattEierandelerIVirksomhetenIHeleEllerDelerAvSoknadsperioden').value === 'ja') {
                <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.eierandel' | translate }}</div>
              }
              <div class="form-grid">
                @if (control('eierandeler.hvaVarStorrelsenPaEierandelenDin').enabled) {
                  <div class="form-field">
                    <label for="hvaVarStorrelsenPaEierandelenDin">
                      {{ 'norge.soknad.felt.hvaVarStorrelsenPaEierandelenDin' | translate }}
    <app-field-help [tooltip]="'norge.soknad.hjelp.hvaVarStorrelsenPaEierandelenDin' | translate"></app-field-help>
                    </label>
                    <input id="hvaVarStorrelsenPaEierandelenDin" type="number" min="0" max="100" step="any" class="form-control" formControlName="hvaVarStorrelsenPaEierandelenDin">
                    @if (fieldErrorKey(control('eierandeler.hvaVarStorrelsenPaEierandelenDin')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('eierandeler.fraHvilkenDatoEideDuDenneAndelenDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="fraHvilkenDatoEideDuDenneAndelenDdMmAaaa">
                      {{ 'norge.soknad.felt.fraHvilkenDatoEideDuDenneAndelenDdMmAaaa' | translate }}
                    </label>
                    <input id="fraHvilkenDatoEideDuDenneAndelenDdMmAaaa" type="date" class="form-control" formControlName="fraHvilkenDatoEideDuDenneAndelenDdMmAaaa">
                    @if (fieldErrorKey(control('eierandeler.fraHvilkenDatoEideDuDenneAndelenDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('eierandeler.tilHvilkenDatoEideDuDenneAndelenDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="tilHvilkenDatoEideDuDenneAndelenDdMmAaaa">
                      {{ 'norge.soknad.felt.tilHvilkenDatoEideDuDenneAndelenDdMmAaaa' | translate }}
                    </label>
                    <input id="tilHvilkenDatoEideDuDenneAndelenDdMmAaaa" type="date" class="form-control" formControlName="tilHvilkenDatoEideDuDenneAndelenDdMmAaaa">
                    @if (fieldErrorKey(control('eierandeler.tilHvilkenDatoEideDuDenneAndelenDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-section" formGroupName="rollerOgRelasjoner">
              <div class="section-title">
                {{ 'norge.soknad.sektion.rollerOgRelasjoner' | translate }}
              </div>
              <div class="process-banner process-banner--info mt-3">
                <div class="process-banner__text">{{ 'norge.soknad.info.alertstripe3' | translate }}</div>
              </div>
              @if (control('rollerOgRelasjoner.harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden-ja" value="ja" formControlName="harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden">
                      <label class="form-check-label" for="harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden-nei" value="nei" formControlName="harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden">
                      <label class="form-check-label" for="harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('rollerOgRelasjoner.harDuHattEnLedendeStillingIVirksomhetenISoknadsperioden')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('rollerOgRelasjoner.hvilkenStillingHaddeDu').enabled) {
                  <div class="form-field">
                    <label for="hvilkenStillingHaddeDu">
                      {{ 'norge.soknad.felt.hvilkenStillingHaddeDu' | translate }}
                    </label>
                    <input id="hvilkenStillingHaddeDu" type="text" class="form-control" formControlName="hvilkenStillingHaddeDu">
                    @if (fieldErrorKey(control('rollerOgRelasjoner.hvilkenStillingHaddeDu')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('rollerOgRelasjoner.harDuVaertStyremedlemISoknadsperioden').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuVaertStyremedlemISoknadsperioden' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuVaertStyremedlemISoknadsperioden-ja" value="ja" formControlName="harDuVaertStyremedlemISoknadsperioden">
                      <label class="form-check-label" for="harDuVaertStyremedlemISoknadsperioden-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuVaertStyremedlemISoknadsperioden-nei" value="nei" formControlName="harDuVaertStyremedlemISoknadsperioden">
                      <label class="form-check-label" for="harDuVaertStyremedlemISoknadsperioden-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('rollerOgRelasjoner.harDuVaertStyremedlemISoknadsperioden')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('rollerOgRelasjoner.varDuArbeidstakernesValgteRepresentant').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.varDuArbeidstakernesValgteRepresentant' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="varDuArbeidstakernesValgteRepresentant-ja" value="ja" formControlName="varDuArbeidstakernesValgteRepresentant">
                      <label class="form-check-label" for="varDuArbeidstakernesValgteRepresentant-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="varDuArbeidstakernesValgteRepresentant-nei" value="nei" formControlName="varDuArbeidstakernesValgteRepresentant">
                      <label class="form-check-label" for="varDuArbeidstakernesValgteRepresentant-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('rollerOgRelasjoner.varDuArbeidstakernesValgteRepresentant')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('rollerOgRelasjoner.harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten-ja" value="ja" formControlName="harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten">
                      <label class="form-check-label" for="harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten-nei" value="nei" formControlName="harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten">
                      <label class="form-check-label" for="harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('rollerOgRelasjoner.harNoenDuHarEnNaerRelasjonTilHattEierandelerEnLedendeStillingEllerVaertStyremedlemIVirksomheten')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('rollerOgRelasjoner.hvaSlagsRelasjonHarHaddeDere').enabled) {
                  <div class="form-field">
                    <label for="hvaSlagsRelasjonHarHaddeDere">
                      {{ 'norge.soknad.felt.hvaSlagsRelasjonHarHaddeDere' | translate }}
                    </label>
                    <input id="hvaSlagsRelasjonHarHaddeDere" type="text" class="form-control" formControlName="hvaSlagsRelasjonHarHaddeDere">
                    @if (fieldErrorKey(control('rollerOgRelasjoner.hvaSlagsRelasjonHarHaddeDere')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('rollerOgRelasjoner.redegjorNaermereForEierandelensStorrelseStillingenEllerVervet').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label for="redegjorNaermereForEierandelensStorrelseStillingenEllerVervet">
                    {{ 'norge.soknad.felt.redegjorNaermereForEierandelensStorrelseStillingenEllerVervet' | translate }}
                  </label>
                  <textarea id="redegjorNaermereForEierandelensStorrelseStillingenEllerVervet" rows="3" class="form-control" formControlName="redegjorNaermereForEierandelensStorrelseStillingenEllerVervet"></textarea>
                  @if (fieldErrorKey(control('rollerOgRelasjoner.redegjorNaermereForEierandelensStorrelseStillingenEllerVervet')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('rollerOgRelasjoner.harDuTidligereFattLonnsgarantidekningIAndreKonkursbo').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuTidligereFattLonnsgarantidekningIAndreKonkursbo' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuTidligereFattLonnsgarantidekningIAndreKonkursbo-ja" value="ja" formControlName="harDuTidligereFattLonnsgarantidekningIAndreKonkursbo">
                      <label class="form-check-label" for="harDuTidligereFattLonnsgarantidekningIAndreKonkursbo-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuTidligereFattLonnsgarantidekningIAndreKonkursbo-nei" value="nei" formControlName="harDuTidligereFattLonnsgarantidekningIAndreKonkursbo">
                      <label class="form-check-label" for="harDuTidligereFattLonnsgarantidekningIAndreKonkursbo-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('rollerOgRelasjoner.harDuTidligereFattLonnsgarantidekningIAndreKonkursbo')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('rollerOgRelasjoner.tidligereKonkursbo').enabled) {
                <div formArrayName="tidligereKonkursbo" class="mt-3">
                  @for (row of array('rollerOgRelasjoner.tidligereKonkursbo').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.tidligereKonkursbo' | translate }} {{ rowIndex + 1 }}</div>
                        @if (array('rollerOgRelasjoner.tidligereKonkursbo').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('rollerOgRelasjoner.tidligereKonkursbo', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'tidligereKonkursbo-navnPaVirksomheten-' + rowIndex">
                      {{ 'norge.soknad.felt.tidligereKonkursbo.navnPaVirksomheten' | translate }}
                    </label>
                    <input [attr.id]="'tidligereKonkursbo-navnPaVirksomheten-' + rowIndex" type="text" class="form-control" formControlName="navnPaVirksomheten">
                    @if (fieldErrorKey(row.get('navnPaVirksomheten')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('rollerOgRelasjoner.tidligereKonkursbo')">{{ 'norge.soknad.knapper.tidligereKonkursbo' | translate }}</button>
                </div>
              }
            </div>

            <div class="form-section" formGroupName="overdragelseAvKrav">
              <div class="section-title">
                {{ 'norge.soknad.sektion.overdragelseAvKrav' | translate }}
              </div>
              <div class="process-banner process-banner--info mt-3">
                <div class="process-banner__text">{{ 'norge.soknad.info.alertstripe4' | translate }}</div>
              </div>
              @if (control('overdragelseAvKrav.erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre-ja" value="ja" formControlName="erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre">
                      <label class="form-check-label" for="erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre-nei" value="nei" formControlName="erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre">
                      <label class="form-check-label" for="erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('overdragelseAvKrav.erKravetDittHeltEllerDelvisOverdrattAvEllerPaAnnenMateGattOverTilAndre')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('overdragelseAvKrav.narBleKravetDittOverdrattDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="narBleKravetDittOverdrattDdMmAaaa">
                      {{ 'norge.soknad.felt.narBleKravetDittOverdrattDdMmAaaa' | translate }}
                    </label>
                    <input id="narBleKravetDittOverdrattDdMmAaaa" type="date" class="form-control" formControlName="narBleKravetDittOverdrattDdMmAaaa">
                    @if (fieldErrorKey(control('overdragelseAvKrav.narBleKravetDittOverdrattDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('overdragelseAvKrav.hvemBleKravetDittOverdrattTil').enabled) {
                  <div class="form-field">
                    <label for="hvemBleKravetDittOverdrattTil">
                      {{ 'norge.soknad.felt.hvemBleKravetDittOverdrattTil' | translate }}
                    </label>
                    <input id="hvemBleKravetDittOverdrattTil" type="text" class="form-control" formControlName="hvemBleKravetDittOverdrattTil">
                    @if (fieldErrorKey(control('overdragelseAvKrav.hvemBleKravetDittOverdrattTil')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-section" formGroupName="sykmeldtPermittertEllerArbeidsledig">
              <div class="section-title">
                {{ 'norge.soknad.sektion.sykmeldtPermittertEllerArbeidsledig' | translate }}
              </div>
              <div class="process-banner process-banner--info mt-3">
                <div class="process-banner__text">{{ 'norge.soknad.info.alertstripe5' | translate }}</div>
              </div>
              @if (control('sykmeldtPermittertEllerArbeidsledig.harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden-ja" value="ja" formControlName="harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden">
                      <label class="form-check-label" for="harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden-nei" value="nei" formControlName="harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden">
                      <label class="form-check-label" for="harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.harDuVaertSykmeldtIHeleEllerDelerAvSoknadsperioden')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('sykmeldtPermittertEllerArbeidsledig.sykmeldingsperiode').enabled) {
                <div formArrayName="sykmeldingsperiode" class="mt-3">
                  @for (row of array('sykmeldtPermittertEllerArbeidsledig.sykmeldingsperiode').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.sykmeldingsperiode' | translate }} {{ rowIndex + 1 }}
              <app-field-help [tooltip]="'norge.soknad.hjelp.sykmeldingsperiode' | translate"></app-field-help></div>
                        @if (array('sykmeldtPermittertEllerArbeidsledig.sykmeldingsperiode').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('sykmeldtPermittertEllerArbeidsledig.sykmeldingsperiode', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'sykmeldingsperiode-sykmeldtFraDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.sykmeldingsperiode.sykmeldtFraDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'sykmeldingsperiode-sykmeldtFraDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="sykmeldtFraDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('sykmeldtFraDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'sykmeldingsperiode-sykmeldtTilDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.sykmeldingsperiode.sykmeldtTilDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'sykmeldingsperiode-sykmeldtTilDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="sykmeldtTilDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('sykmeldtTilDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'sykmeldingsperiode-sykmeldingsgrad-' + rowIndex">
                      {{ 'norge.soknad.felt.sykmeldingsperiode.sykmeldingsgrad' | translate }}
                    <app-field-help [tooltip]="'norge.soknad.hjelp.sykmeldingsgrad' | translate"></app-field-help>
                    </label>
                    <input [attr.id]="'sykmeldingsperiode-sykmeldingsgrad-' + rowIndex" type="number" min="0" max="100" step="any" class="form-control" formControlName="sykmeldingsgrad">
                    @if (fieldErrorKey(row.get('sykmeldingsgrad')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('sykmeldtPermittertEllerArbeidsledig.sykmeldingsperiode')">{{ 'norge.soknad.knapper.sykmeldingsperiode' | translate }}</button>
                </div>
              }
              @if (control('sykmeldtPermittertEllerArbeidsledig.harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden-ja" value="ja" formControlName="harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden">
                      <label class="form-check-label" for="harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden-nei" value="nei" formControlName="harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden">
                      <label class="form-check-label" for="harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.harDuVaertPermittertIHeleEllerDelerAvSoknadsperioden')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('sykmeldtPermittertEllerArbeidsledig.permitteringsperiodeR').enabled) {
                <div formArrayName="permitteringsperiodeR" class="mt-3">
                  @for (row of array('sykmeldtPermittertEllerArbeidsledig.permitteringsperiodeR').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.permitteringsperiodeR' | translate }} {{ rowIndex + 1 }}
              <app-field-help [tooltip]="'norge.soknad.hjelp.permitteringsperiodeR' | translate"></app-field-help></div>
                        @if (array('sykmeldtPermittertEllerArbeidsledig.permitteringsperiodeR').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('sykmeldtPermittertEllerArbeidsledig.permitteringsperiodeR', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'permitteringsperiodeR-permittertFraDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.permitteringsperiodeR.permittertFraDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'permitteringsperiodeR-permittertFraDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="permittertFraDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('permittertFraDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'permitteringsperiodeR-permittertTilDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.permitteringsperiodeR.permittertTilDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'permitteringsperiodeR-permittertTilDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="permittertTilDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('permittertTilDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'permitteringsperiodeR-permitteringsgrad-' + rowIndex">
                      {{ 'norge.soknad.felt.permitteringsperiodeR.permitteringsgrad' | translate }}
                    <app-field-help [tooltip]="'norge.soknad.hjelp.permitteringsgrad' | translate"></app-field-help>
                    </label>
                    <input [attr.id]="'permitteringsperiodeR-permitteringsgrad-' + rowIndex" type="number" min="0" max="100" step="any" class="form-control" formControlName="permitteringsgrad">
                    @if (fieldErrorKey(row.get('permitteringsgrad')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('sykmeldtPermittertEllerArbeidsledig.permitteringsperiodeR')">{{ 'norge.soknad.knapper.permitteringsperiodeR' | translate }}</button>
                </div>
              }
              @if (control('sykmeldtPermittertEllerArbeidsledig.harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden-ja" value="ja" formControlName="harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden">
                      <label class="form-check-label" for="harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden-nei" value="nei" formControlName="harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden">
                      <label class="form-check-label" for="harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.harDuHattLonnetForeldrepermisjonIHeleEllerDelerAvSoknadsperioden')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('sykmeldtPermittertEllerArbeidsledig.foreldrepermisjonsperiodeR').enabled) {
                <div formArrayName="foreldrepermisjonsperiodeR" class="mt-3">
                  @for (row of array('sykmeldtPermittertEllerArbeidsledig.foreldrepermisjonsperiodeR').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.foreldrepermisjonsperiodeR' | translate }} {{ rowIndex + 1 }}</div>
                        @if (array('sykmeldtPermittertEllerArbeidsledig.foreldrepermisjonsperiodeR').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('sykmeldtPermittertEllerArbeidsledig.foreldrepermisjonsperiodeR', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'foreldrepermisjonsperiodeR-fraDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.foreldrepermisjonsperiodeR.fraDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'foreldrepermisjonsperiodeR-fraDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="fraDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('fraDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'foreldrepermisjonsperiodeR-tilDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.foreldrepermisjonsperiodeR.tilDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'foreldrepermisjonsperiodeR-tilDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="tilDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('tilDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('sykmeldtPermittertEllerArbeidsledig.foreldrepermisjonsperiodeR')">{{ 'norge.soknad.knapper.foreldrepermisjonsperiodeR' | translate }}</button>
                </div>
              }
              @if (control('sykmeldtPermittertEllerArbeidsledig.harDuMeldtDegForNavSomArbeidssoker').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuMeldtDegForNavSomArbeidssoker' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuMeldtDegForNavSomArbeidssoker-ja" value="ja" formControlName="harDuMeldtDegForNavSomArbeidssoker">
                      <label class="form-check-label" for="harDuMeldtDegForNavSomArbeidssoker-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuMeldtDegForNavSomArbeidssoker-nei" value="nei" formControlName="harDuMeldtDegForNavSomArbeidssoker">
                      <label class="form-check-label" for="harDuMeldtDegForNavSomArbeidssoker-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.harDuMeldtDegForNavSomArbeidssoker')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('sykmeldtPermittertEllerArbeidsledig.fraHvilkenDatoErDuRegistrertSomArbeidssokerDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="fraHvilkenDatoErDuRegistrertSomArbeidssokerDdMmAaaa">
                      {{ 'norge.soknad.felt.fraHvilkenDatoErDuRegistrertSomArbeidssokerDdMmAaaa' | translate }}
                    </label>
                    <input id="fraHvilkenDatoErDuRegistrertSomArbeidssokerDdMmAaaa" type="date" class="form-control" formControlName="fraHvilkenDatoErDuRegistrertSomArbeidssokerDdMmAaaa">
                    @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.fraHvilkenDatoErDuRegistrertSomArbeidssokerDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
              @if (control('sykmeldtPermittertEllerArbeidsledig.forklarArsakenTilAtDuIkkeHarMeldDegForNavSomArbeidssoker').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label for="forklarArsakenTilAtDuIkkeHarMeldDegForNavSomArbeidssoker">
                    {{ 'norge.soknad.felt.forklarArsakenTilAtDuIkkeHarMeldDegForNavSomArbeidssoker' | translate }}
                  </label>
                  <textarea id="forklarArsakenTilAtDuIkkeHarMeldDegForNavSomArbeidssoker" rows="3" class="form-control" formControlName="forklarArsakenTilAtDuIkkeHarMeldDegForNavSomArbeidssoker"></textarea>
                  @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.forklarArsakenTilAtDuIkkeHarMeldDegForNavSomArbeidssoker')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('sykmeldtPermittertEllerArbeidsledig.harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen-ja" value="ja" formControlName="harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen">
                      <label class="form-check-label" for="harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen-nei" value="nei" formControlName="harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen">
                      <label class="form-check-label" for="harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.harDuAlleredeFattEllerRegnerDuMedAFaArbeidIgjen')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('sykmeldtPermittertEllerArbeidsledig.fraHvilkenDatoHarDuEllerRegnerDuMedAStarteINyttArbeidIgjenDdMmAaaa').enabled) {
                  <div class="form-field">
                    <label for="fraHvilkenDatoHarDuEllerRegnerDuMedAStarteINyttArbeidIgjenDdMmAaaa">
                      {{ 'norge.soknad.felt.fraHvilkenDatoHarDuEllerRegnerDuMedAStarteINyttArbeidIgjenDdMmAaaa' | translate }}
                    </label>
                    <input id="fraHvilkenDatoHarDuEllerRegnerDuMedAStarteINyttArbeidIgjenDdMmAaaa" type="date" class="form-control" formControlName="fraHvilkenDatoHarDuEllerRegnerDuMedAStarteINyttArbeidIgjenDdMmAaaa">
                    @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.fraHvilkenDatoHarDuEllerRegnerDuMedAStarteINyttArbeidIgjenDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
                @if (control('sykmeldtPermittertEllerArbeidsledig.navnPaNyArbeidsgiver').enabled) {
                  <div class="form-field">
                    <label for="navnPaNyArbeidsgiver">
                      {{ 'norge.soknad.felt.navnPaNyArbeidsgiver' | translate }}
                    </label>
                    <input id="navnPaNyArbeidsgiver" type="text" class="form-control" formControlName="navnPaNyArbeidsgiver">
                    @if (fieldErrorKey(control('sykmeldtPermittertEllerArbeidsledig.navnPaNyArbeidsgiver')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-section" formGroupName="lonnsOgFeriepengekrav">
              <div class="section-title">
                {{ 'norge.soknad.sektion.lonnsOgFeriepengekrav' | translate }}
              </div>
              @if (control('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.hvaSlagsKravOnskerDuASendeInn' | translate }}
                  </label>
                  <div class="d-flex flex-wrap gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsKravOnskerDuASendeInn-lonn" [checked]="isOptionChecked('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn', 'lonn')" (change)="toggleOption('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn', 'lonn')">
                      <label class="form-check-label" for="hvaSlagsKravOnskerDuASendeInn-lonn">{{ 'norge.soknad.valg.lonn' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsKravOnskerDuASendeInn-annetArbeidsvederlag" [checked]="isOptionChecked('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn', 'annetArbeidsvederlag')" (change)="toggleOption('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn', 'annetArbeidsvederlag')">
                      <label class="form-check-label" for="hvaSlagsKravOnskerDuASendeInn-annetArbeidsvederlag">{{ 'norge.soknad.valg.annetArbeidsvederlag' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsKravOnskerDuASendeInn-feriepenger" [checked]="isOptionChecked('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn', 'feriepenger')" (change)="toggleOption('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn', 'feriepenger')">
                      <label class="form-check-label" for="hvaSlagsKravOnskerDuASendeInn-feriepenger">{{ 'norge.soknad.valg.feriepenger' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsKravOnskerDuASendeInn-andreKrav" [checked]="isOptionChecked('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn', 'andreKrav')" (change)="toggleOption('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn', 'andreKrav')">
                      <label class="form-check-label" for="hvaSlagsKravOnskerDuASendeInn-andreKrav">{{ 'norge.soknad.valg.andreKrav' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('lonnsOgFeriepengekrav.hvaSlagsKravOnskerDuASendeInn')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('lonnsOgFeriepengekrav.fastBruttolonn').enabled) {
                <div formArrayName="fastBruttolonn" class="mt-3">
                  @for (row of array('lonnsOgFeriepengekrav.fastBruttolonn').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.fastBruttolonn' | translate }} {{ rowIndex + 1 }}
              <app-field-help [tooltip]="'norge.soknad.hjelp.fastBruttolonn' | translate"></app-field-help></div>
                        @if (array('lonnsOgFeriepengekrav.fastBruttolonn').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('lonnsOgFeriepengekrav.fastBruttolonn', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'fastBruttolonn-bruttolonn-' + rowIndex">
                      {{ 'norge.soknad.felt.fastBruttolonn.bruttolonn' | translate }}
                    </label>
                    <app-decimal-input formControlName="bruttolonn"></app-decimal-input>
                    @if (fieldErrorKey(row.get('bruttolonn')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'fastBruttolonn-fraOgMedDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.fastBruttolonn.fraOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'fastBruttolonn-fraOgMedDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('fraOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'fastBruttolonn-tilOgMedDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.fastBruttolonn.tilOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'fastBruttolonn-tilOgMedDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('tilOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('lonnsOgFeriepengekrav.fastBruttolonn')">{{ 'norge.soknad.knapper.fastBruttolonn' | translate }}</button>
                </div>
              }
              @if (control('lonnsOgFeriepengekrav.annetArbeidsvederlag').enabled) {
                <div formArrayName="annetArbeidsvederlag" class="mt-3">
                  @for (row of array('lonnsOgFeriepengekrav.annetArbeidsvederlag').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.annetArbeidsvederlag' | translate }} {{ rowIndex + 1 }}
              <app-field-help [tooltip]="'norge.soknad.hjelp.annetArbeidsvederlag' | translate"></app-field-help></div>
                        @if (array('lonnsOgFeriepengekrav.annetArbeidsvederlag').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('lonnsOgFeriepengekrav.annetArbeidsvederlag', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'annetArbeidsvederlag-belop-' + rowIndex">
                      {{ 'norge.soknad.felt.annetArbeidsvederlag.belop' | translate }}
                    </label>
                    <app-decimal-input formControlName="belop"></app-decimal-input>
                    @if (fieldErrorKey(row.get('belop')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'annetArbeidsvederlag-fraOgMedDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.annetArbeidsvederlag.fraOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'annetArbeidsvederlag-fraOgMedDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('fraOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'annetArbeidsvederlag-tilOgMedDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.annetArbeidsvederlag.tilOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'annetArbeidsvederlag-tilOgMedDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('tilOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'annetArbeidsvederlag-forklaringSpesifiseringAvArbeidsvederlaget-' + rowIndex">
                      {{ 'norge.soknad.felt.annetArbeidsvederlag.forklaringSpesifiseringAvArbeidsvederlaget' | translate }}
                    </label>
                    <textarea [attr.id]="'annetArbeidsvederlag-forklaringSpesifiseringAvArbeidsvederlaget-' + rowIndex" rows="3" class="form-control" formControlName="forklaringSpesifiseringAvArbeidsvederlaget"></textarea>
                    @if (fieldErrorKey(row.get('forklaringSpesifiseringAvArbeidsvederlaget')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('lonnsOgFeriepengekrav.annetArbeidsvederlag')">{{ 'norge.soknad.knapper.annetArbeidsvederlag' | translate }}</button>
                </div>
              }
              @if (control('lonnsOgFeriepengekrav.feriepenger').enabled) {
                <div formArrayName="feriepenger" class="mt-3">
                  @for (row of array('lonnsOgFeriepengekrav.feriepenger').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.feriepenger' | translate }} {{ rowIndex + 1 }}
              <app-field-help [tooltip]="'norge.soknad.hjelp.feriepenger' | translate"></app-field-help></div>
                        @if (array('lonnsOgFeriepengekrav.feriepenger').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('lonnsOgFeriepengekrav.feriepenger', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'feriepenger-belop-' + rowIndex">
                      {{ 'norge.soknad.felt.feriepenger.belop' | translate }}
                    </label>
                    <app-decimal-input formControlName="belop"></app-decimal-input>
                    @if (fieldErrorKey(row.get('belop')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'feriepenger-opptjentFraOgMedDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.feriepenger.opptjentFraOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'feriepenger-opptjentFraOgMedDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="opptjentFraOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('opptjentFraOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'feriepenger-opptjentTilOgMedDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.feriepenger.opptjentTilOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'feriepenger-opptjentTilOgMedDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="opptjentTilOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('opptjentTilOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('lonnsOgFeriepengekrav.feriepenger')">{{ 'norge.soknad.knapper.feriepenger' | translate }}</button>
                </div>
              }
              @if (control('lonnsOgFeriepengekrav.andreKrav').enabled) {
                <div formArrayName="andreKrav" class="mt-3">
                  @for (row of array('lonnsOgFeriepengekrav.andreKrav').controls; track row; let rowIndex = $index) {
                    <div [formGroupName]="rowIndex" class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>{{ 'norge.soknad.overskrift.andreKrav' | translate }} {{ rowIndex + 1 }}
              <app-field-help [tooltip]="'norge.soknad.hjelp.andreKrav' | translate"></app-field-help></div>
                        @if (array('lonnsOgFeriepengekrav.andreKrav').length > 1) {
                          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="removeRow('lonnsOgFeriepengekrav.andreKrav', rowIndex)">{{ 'norge.soknad.knapper.fjern-rad' | translate }}</button>
                        }
                      </div>
                      <div class="card-body">
                        <div class="form-grid">
                  <div class="form-field">
                    <label [attr.for]="'andreKrav-bruttobelop-' + rowIndex">
                      {{ 'norge.soknad.felt.andreKrav.bruttobelop' | translate }}
                    </label>
                    <app-decimal-input formControlName="bruttobelop"></app-decimal-input>
                    @if (fieldErrorKey(row.get('bruttobelop')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'andreKrav-fraOgMedDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.andreKrav.fraOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'andreKrav-fraOgMedDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('fraOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'andreKrav-tilOgMedDatoDdMmAaaa-' + rowIndex">
                      {{ 'norge.soknad.felt.andreKrav.tilOgMedDatoDdMmAaaa' | translate }}
                    </label>
                    <input [attr.id]="'andreKrav-tilOgMedDatoDdMmAaaa-' + rowIndex" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
                    @if (fieldErrorKey(row.get('tilOgMedDatoDdMmAaaa')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                  <div class="form-field">
                    <label [attr.for]="'andreKrav-forklaringSpesifiseringAvKravet-' + rowIndex">
                      {{ 'norge.soknad.felt.andreKrav.forklaringSpesifiseringAvKravet' | translate }}
                    </label>
                    <textarea [attr.id]="'andreKrav-forklaringSpesifiseringAvKravet-' + rowIndex" rows="3" class="form-control" formControlName="forklaringSpesifiseringAvKravet"></textarea>
                    @if (fieldErrorKey(row.get('forklaringSpesifiseringAvKravet')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-sm btn-blue text-bold" (click)="addRow('lonnsOgFeriepengekrav.andreKrav')">{{ 'norge.soknad.knapper.andreKrav' | translate }}</button>
                </div>
              }
            </div>

            <div class="form-section" formGroupName="utgifterIForbindelseMedKonkursbegjaering">
              <div class="section-title">
                {{ 'norge.soknad.sektion.utgifterIForbindelseMedKonkursbegjaering' | translate }}
              </div>
              @if (control('utgifterIForbindelseMedKonkursbegjaering.harDuHattUtgifterIForbindelseMedKonkursbegjaeringen').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuHattUtgifterIForbindelseMedKonkursbegjaeringen' | translate }}
    <app-field-help [tooltip]="'norge.soknad.hjelp.harDuHattUtgifterIForbindelseMedKonkursbegjaeringen' | translate"></app-field-help>
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattUtgifterIForbindelseMedKonkursbegjaeringen-ja" value="ja" formControlName="harDuHattUtgifterIForbindelseMedKonkursbegjaeringen">
                      <label class="form-check-label" for="harDuHattUtgifterIForbindelseMedKonkursbegjaeringen-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattUtgifterIForbindelseMedKonkursbegjaeringen-nei" value="nei" formControlName="harDuHattUtgifterIForbindelseMedKonkursbegjaeringen">
                      <label class="form-check-label" for="harDuHattUtgifterIForbindelseMedKonkursbegjaeringen-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('utgifterIForbindelseMedKonkursbegjaering.harDuHattUtgifterIForbindelseMedKonkursbegjaeringen')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              <div class="form-grid">
                @if (control('utgifterIForbindelseMedKonkursbegjaering.oppgiBelop').enabled) {
                  <div class="form-field">
                    <label for="oppgiBelop">
                      {{ 'norge.soknad.felt.oppgiBelop' | translate }}
                    </label>
                    <app-decimal-input formControlName="oppgiBelop"></app-decimal-input>
                    @if (fieldErrorKey(control('utgifterIForbindelseMedKonkursbegjaering.oppgiBelop')); as errorKey) {
                      <small class="text-danger">{{ errorKey | translate }}</small>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-section" formGroupName="fradragForAndreInntekter">
              <div class="section-title">
                {{ 'norge.soknad.sektion.fradragForAndreInntekter' | translate }}
              </div>
              <div class="process-banner process-banner--info mt-3">
                <div class="process-banner__text">{{ 'norge.soknad.info.alertstripe6' | translate }}</div>
              </div>
              @if (control('fradragForAndreInntekter.harDuHattAndreInntekterISoknadsperioden').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.harDuHattAndreInntekterISoknadsperioden' | translate }}
                  </label>
                  <div class="d-flex gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattAndreInntekterISoknadsperioden-ja" value="ja" formControlName="harDuHattAndreInntekterISoknadsperioden">
                      <label class="form-check-label" for="harDuHattAndreInntekterISoknadsperioden-ja">{{ 'button.ja' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="harDuHattAndreInntekterISoknadsperioden-nei" value="nei" formControlName="harDuHattAndreInntekterISoknadsperioden">
                      <label class="form-check-label" for="harDuHattAndreInntekterISoknadsperioden-nei">{{ 'button.nej' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('fradragForAndreInntekter.harDuHattAndreInntekterISoknadsperioden')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label>
                    {{ 'norge.soknad.felt.hvaSlagsInntektHarDuHattISoknadsperioden' | translate }}
                  </label>
                  <div class="d-flex flex-wrap gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsInntektHarDuHattISoknadsperioden-lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver" [checked]="isOptionChecked('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver')" (change)="toggleOption('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver')">
                      <label class="form-check-label" for="hvaSlagsInntektHarDuHattISoknadsperioden-lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver">{{ 'norge.soknad.valg.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsInntektHarDuHattISoknadsperioden-inntektFraSelvstendigNaering" [checked]="isOptionChecked('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'inntektFraSelvstendigNaering')" (change)="toggleOption('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'inntektFraSelvstendigNaering')">
                      <label class="form-check-label" for="hvaSlagsInntektHarDuHattISoknadsperioden-inntektFraSelvstendigNaering">{{ 'norge.soknad.valg.inntektFraSelvstendigNaering' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsInntektHarDuHattISoknadsperioden-dagpengerUnderArbeidsloshet" [checked]="isOptionChecked('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'dagpengerUnderArbeidsloshet')" (change)="toggleOption('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'dagpengerUnderArbeidsloshet')">
                      <label class="form-check-label" for="hvaSlagsInntektHarDuHattISoknadsperioden-dagpengerUnderArbeidsloshet">{{ 'norge.soknad.valg.dagpengerUnderArbeidsloshet' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsInntektHarDuHattISoknadsperioden-sykepengerFraNav" [checked]="isOptionChecked('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'sykepengerFraNav')" (change)="toggleOption('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'sykepengerFraNav')">
                      <label class="form-check-label" for="hvaSlagsInntektHarDuHattISoknadsperioden-sykepengerFraNav">{{ 'norge.soknad.valg.sykepengerFraNav' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsInntektHarDuHattISoknadsperioden-andreYtelserFraNav" [checked]="isOptionChecked('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'andreYtelserFraNav')" (change)="toggleOption('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'andreYtelserFraNav')">
                      <label class="form-check-label" for="hvaSlagsInntektHarDuHattISoknadsperioden-andreYtelserFraNav">{{ 'norge.soknad.valg.andreYtelserFraNav' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="hvaSlagsInntektHarDuHattISoknadsperioden-eventuelleAndreInntekterEllerYtelser" [checked]="isOptionChecked('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'eventuelleAndreInntekterEllerYtelser')" (change)="toggleOption('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden', 'eventuelleAndreInntekterEllerYtelser')">
                      <label class="form-check-label" for="hvaSlagsInntektHarDuHattISoknadsperioden-eventuelleAndreInntekterEllerYtelser">{{ 'norge.soknad.valg.eventuelleAndreInntekterEllerYtelser' | translate }}</label>
                    </div>
                  </div>
                  @if (fieldErrorKey(control('fradragForAndreInntekter.hvaSlagsInntektHarDuHattISoknadsperioden')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
              @if (control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver').enabled) {
                <div formGroupName="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver">
                  <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver' | translate }}</div>
                  <div class="form-grid">
        @if (control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.bruttobelop').enabled) {
          <div class="form-field">
            <label for="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-bruttobelop">
              {{ 'norge.soknad.felt.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.bruttobelop' | translate }}
            </label>
            <app-decimal-input formControlName="bruttobelop"></app-decimal-input>
            @if (fieldErrorKey(control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.bruttobelop')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.fraOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-fraOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.fraOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-fraOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.fraOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.tilOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-tilOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.tilOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-tilOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.tilOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
      </div>
      @if (control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.kanBelopetTrekkesFraLonnskravetDitt').enabled) {
        <div class="form-field mt-3 mb-3">
          <label>
            {{ 'norge.soknad.felt.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.kanBelopetTrekkesFraLonnskravetDitt' | translate }}
          </label>
          <div class="d-flex gap-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-kanBelopetTrekkesFraLonnskravetDitt-ja" value="ja" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-kanBelopetTrekkesFraLonnskravetDitt-ja">{{ 'button.ja' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-kanBelopetTrekkesFraLonnskravetDitt-nei" value="nei" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver-kanBelopetTrekkesFraLonnskravetDitt-nei">{{ 'button.nej' | translate }}</label>
            </div>
          </div>
          @if (fieldErrorKey(control('fradragForAndreInntekter.lonnOgAnnetArbeidsvederlagHosAnnenArbeidsgiver.kanBelopetTrekkesFraLonnskravetDitt')); as errorKey) {
            <small class="text-danger">{{ errorKey | translate }}</small>
          }
        </div>
      }
                </div>
              }
              @if (control('fradragForAndreInntekter.inntektFraSelvstendigNaering').enabled) {
                <div formGroupName="inntektFraSelvstendigNaering">
                  <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.inntektFraSelvstendigNaering' | translate }}</div>
                  <div class="form-grid">
        @if (control('fradragForAndreInntekter.inntektFraSelvstendigNaering.bruttobelop').enabled) {
          <div class="form-field">
            <label for="inntektFraSelvstendigNaering-bruttobelop">
              {{ 'norge.soknad.felt.inntektFraSelvstendigNaering.bruttobelop' | translate }}
            </label>
            <app-decimal-input formControlName="bruttobelop"></app-decimal-input>
            @if (fieldErrorKey(control('fradragForAndreInntekter.inntektFraSelvstendigNaering.bruttobelop')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.inntektFraSelvstendigNaering.fraOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="inntektFraSelvstendigNaering-fraOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.inntektFraSelvstendigNaering.fraOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="inntektFraSelvstendigNaering-fraOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.inntektFraSelvstendigNaering.fraOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.inntektFraSelvstendigNaering.tilOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="inntektFraSelvstendigNaering-tilOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.inntektFraSelvstendigNaering.tilOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="inntektFraSelvstendigNaering-tilOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.inntektFraSelvstendigNaering.tilOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
      </div>
      @if (control('fradragForAndreInntekter.inntektFraSelvstendigNaering.kanBelopetTrekkesFraLonnskravetDitt').enabled) {
        <div class="form-field mt-3 mb-3">
          <label>
            {{ 'norge.soknad.felt.inntektFraSelvstendigNaering.kanBelopetTrekkesFraLonnskravetDitt' | translate }}
          </label>
          <div class="d-flex gap-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="inntektFraSelvstendigNaering-kanBelopetTrekkesFraLonnskravetDitt-ja" value="ja" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="inntektFraSelvstendigNaering-kanBelopetTrekkesFraLonnskravetDitt-ja">{{ 'button.ja' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="inntektFraSelvstendigNaering-kanBelopetTrekkesFraLonnskravetDitt-nei" value="nei" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="inntektFraSelvstendigNaering-kanBelopetTrekkesFraLonnskravetDitt-nei">{{ 'button.nej' | translate }}</label>
            </div>
          </div>
          @if (fieldErrorKey(control('fradragForAndreInntekter.inntektFraSelvstendigNaering.kanBelopetTrekkesFraLonnskravetDitt')); as errorKey) {
            <small class="text-danger">{{ errorKey | translate }}</small>
          }
        </div>
      }
                </div>
              }
              @if (control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet').enabled) {
                <div formGroupName="dagpengerUnderArbeidsloshet">
                  <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.dagpengerUnderArbeidsloshet' | translate }}</div>
                  <div class="form-grid">
        @if (control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet.bruttobelop').enabled) {
          <div class="form-field">
            <label for="dagpengerUnderArbeidsloshet-bruttobelop">
              {{ 'norge.soknad.felt.dagpengerUnderArbeidsloshet.bruttobelop' | translate }}
            </label>
            <app-decimal-input formControlName="bruttobelop"></app-decimal-input>
            @if (fieldErrorKey(control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet.bruttobelop')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet.fraOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="dagpengerUnderArbeidsloshet-fraOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.dagpengerUnderArbeidsloshet.fraOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="dagpengerUnderArbeidsloshet-fraOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet.fraOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet.tilOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="dagpengerUnderArbeidsloshet-tilOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.dagpengerUnderArbeidsloshet.tilOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="dagpengerUnderArbeidsloshet-tilOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet.tilOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
      </div>
      @if (control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet.kanBelopetTrekkesFraLonnskravetDitt').enabled) {
        <div class="form-field mt-3 mb-3">
          <label>
            {{ 'norge.soknad.felt.dagpengerUnderArbeidsloshet.kanBelopetTrekkesFraLonnskravetDitt' | translate }}
          </label>
          <div class="d-flex gap-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="dagpengerUnderArbeidsloshet-kanBelopetTrekkesFraLonnskravetDitt-ja" value="ja" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="dagpengerUnderArbeidsloshet-kanBelopetTrekkesFraLonnskravetDitt-ja">{{ 'button.ja' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="dagpengerUnderArbeidsloshet-kanBelopetTrekkesFraLonnskravetDitt-nei" value="nei" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="dagpengerUnderArbeidsloshet-kanBelopetTrekkesFraLonnskravetDitt-nei">{{ 'button.nej' | translate }}</label>
            </div>
          </div>
          @if (fieldErrorKey(control('fradragForAndreInntekter.dagpengerUnderArbeidsloshet.kanBelopetTrekkesFraLonnskravetDitt')); as errorKey) {
            <small class="text-danger">{{ errorKey | translate }}</small>
          }
        </div>
      }
                </div>
              }
              @if (control('fradragForAndreInntekter.sykepengerFraNav').enabled) {
                <div formGroupName="sykepengerFraNav">
                  <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.sykepengerFraNav' | translate }}</div>
                  <div class="form-grid">
        @if (control('fradragForAndreInntekter.sykepengerFraNav.bruttobelop').enabled) {
          <div class="form-field">
            <label for="sykepengerFraNav-bruttobelop">
              {{ 'norge.soknad.felt.sykepengerFraNav.bruttobelop' | translate }}
            </label>
            <app-decimal-input formControlName="bruttobelop"></app-decimal-input>
            @if (fieldErrorKey(control('fradragForAndreInntekter.sykepengerFraNav.bruttobelop')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.sykepengerFraNav.fraOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="sykepengerFraNav-fraOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.sykepengerFraNav.fraOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="sykepengerFraNav-fraOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.sykepengerFraNav.fraOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.sykepengerFraNav.tilOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="sykepengerFraNav-tilOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.sykepengerFraNav.tilOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="sykepengerFraNav-tilOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.sykepengerFraNav.tilOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
      </div>
      @if (control('fradragForAndreInntekter.sykepengerFraNav.kanBelopetTrekkesFraLonnskravetDitt').enabled) {
        <div class="form-field mt-3 mb-3">
          <label>
            {{ 'norge.soknad.felt.sykepengerFraNav.kanBelopetTrekkesFraLonnskravetDitt' | translate }}
          </label>
          <div class="d-flex gap-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="sykepengerFraNav-kanBelopetTrekkesFraLonnskravetDitt-ja" value="ja" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="sykepengerFraNav-kanBelopetTrekkesFraLonnskravetDitt-ja">{{ 'button.ja' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="sykepengerFraNav-kanBelopetTrekkesFraLonnskravetDitt-nei" value="nei" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="sykepengerFraNav-kanBelopetTrekkesFraLonnskravetDitt-nei">{{ 'button.nej' | translate }}</label>
            </div>
          </div>
          @if (fieldErrorKey(control('fradragForAndreInntekter.sykepengerFraNav.kanBelopetTrekkesFraLonnskravetDitt')); as errorKey) {
            <small class="text-danger">{{ errorKey | translate }}</small>
          }
        </div>
      }
                </div>
              }
              @if (control('fradragForAndreInntekter.andreYtelserFraNav').enabled) {
                <div formGroupName="andreYtelserFraNav">
                  <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.andreYtelserFraNav' | translate }}</div>
                  <div class="form-grid">
        @if (control('fradragForAndreInntekter.andreYtelserFraNav.bruttobelop').enabled) {
          <div class="form-field">
            <label for="andreYtelserFraNav-bruttobelop">
              {{ 'norge.soknad.felt.andreYtelserFraNav.bruttobelop' | translate }}
            </label>
            <app-decimal-input formControlName="bruttobelop"></app-decimal-input>
            @if (fieldErrorKey(control('fradragForAndreInntekter.andreYtelserFraNav.bruttobelop')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.andreYtelserFraNav.hvaSlagsYtelse').enabled) {
          <div class="form-field">
            <label for="andreYtelserFraNav-hvaSlagsYtelse">
              {{ 'norge.soknad.felt.andreYtelserFraNav.hvaSlagsYtelse' | translate }}
            </label>
            <input id="andreYtelserFraNav-hvaSlagsYtelse" type="text" class="form-control" formControlName="hvaSlagsYtelse">
            @if (fieldErrorKey(control('fradragForAndreInntekter.andreYtelserFraNav.hvaSlagsYtelse')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.andreYtelserFraNav.fraOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="andreYtelserFraNav-fraOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.andreYtelserFraNav.fraOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="andreYtelserFraNav-fraOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.andreYtelserFraNav.fraOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.andreYtelserFraNav.tilOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="andreYtelserFraNav-tilOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.andreYtelserFraNav.tilOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="andreYtelserFraNav-tilOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.andreYtelserFraNav.tilOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
      </div>
      @if (control('fradragForAndreInntekter.andreYtelserFraNav.kanBelopetTrekkesFraLonnskravetDitt').enabled) {
        <div class="form-field mt-3 mb-3">
          <label>
            {{ 'norge.soknad.felt.andreYtelserFraNav.kanBelopetTrekkesFraLonnskravetDitt' | translate }}
          </label>
          <div class="d-flex gap-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="andreYtelserFraNav-kanBelopetTrekkesFraLonnskravetDitt-ja" value="ja" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="andreYtelserFraNav-kanBelopetTrekkesFraLonnskravetDitt-ja">{{ 'button.ja' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="andreYtelserFraNav-kanBelopetTrekkesFraLonnskravetDitt-nei" value="nei" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="andreYtelserFraNav-kanBelopetTrekkesFraLonnskravetDitt-nei">{{ 'button.nej' | translate }}</label>
            </div>
          </div>
          @if (fieldErrorKey(control('fradragForAndreInntekter.andreYtelserFraNav.kanBelopetTrekkesFraLonnskravetDitt')); as errorKey) {
            <small class="text-danger">{{ errorKey | translate }}</small>
          }
        </div>
      }
                </div>
              }
              @if (control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser').enabled) {
                <div formGroupName="eventuelleAndreInntekterEllerYtelser">
                  <div class="section-subtitle fw-bold mt-4 mb-2">{{ 'norge.soknad.overskrift.eventuelleAndreInntekterEllerYtelser' | translate }}</div>
                  <div class="form-grid">
        @if (control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.bruttobelop').enabled) {
          <div class="form-field">
            <label for="eventuelleAndreInntekterEllerYtelser-bruttobelop">
              {{ 'norge.soknad.felt.eventuelleAndreInntekterEllerYtelser.bruttobelop' | translate }}
            </label>
            <app-decimal-input formControlName="bruttobelop"></app-decimal-input>
            @if (fieldErrorKey(control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.bruttobelop')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.hvaSlagsYtelse').enabled) {
          <div class="form-field">
            <label for="eventuelleAndreInntekterEllerYtelser-hvaSlagsYtelse">
              {{ 'norge.soknad.felt.eventuelleAndreInntekterEllerYtelser.hvaSlagsYtelse' | translate }}
            </label>
            <input id="eventuelleAndreInntekterEllerYtelser-hvaSlagsYtelse" type="text" class="form-control" formControlName="hvaSlagsYtelse">
            @if (fieldErrorKey(control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.hvaSlagsYtelse')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.fraOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="eventuelleAndreInntekterEllerYtelser-fraOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.eventuelleAndreInntekterEllerYtelser.fraOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="eventuelleAndreInntekterEllerYtelser-fraOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="fraOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.fraOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
        @if (control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.tilOgMedDatoDdMmAaaa').enabled) {
          <div class="form-field">
            <label for="eventuelleAndreInntekterEllerYtelser-tilOgMedDatoDdMmAaaa">
              {{ 'norge.soknad.felt.eventuelleAndreInntekterEllerYtelser.tilOgMedDatoDdMmAaaa' | translate }}
            </label>
            <input id="eventuelleAndreInntekterEllerYtelser-tilOgMedDatoDdMmAaaa" type="date" class="form-control" formControlName="tilOgMedDatoDdMmAaaa">
            @if (fieldErrorKey(control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.tilOgMedDatoDdMmAaaa')); as errorKey) {
              <small class="text-danger">{{ errorKey | translate }}</small>
            }
          </div>
        }
      </div>
      @if (control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.kanBelopetTrekkesFraLonnskravetDitt').enabled) {
        <div class="form-field mt-3 mb-3">
          <label>
            {{ 'norge.soknad.felt.eventuelleAndreInntekterEllerYtelser.kanBelopetTrekkesFraLonnskravetDitt' | translate }}
          </label>
          <div class="d-flex gap-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="eventuelleAndreInntekterEllerYtelser-kanBelopetTrekkesFraLonnskravetDitt-ja" value="ja" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="eventuelleAndreInntekterEllerYtelser-kanBelopetTrekkesFraLonnskravetDitt-ja">{{ 'button.ja' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="eventuelleAndreInntekterEllerYtelser-kanBelopetTrekkesFraLonnskravetDitt-nei" value="nei" formControlName="kanBelopetTrekkesFraLonnskravetDitt">
              <label class="form-check-label" for="eventuelleAndreInntekterEllerYtelser-kanBelopetTrekkesFraLonnskravetDitt-nei">{{ 'button.nej' | translate }}</label>
            </div>
          </div>
          @if (fieldErrorKey(control('fradragForAndreInntekter.eventuelleAndreInntekterEllerYtelser.kanBelopetTrekkesFraLonnskravetDitt')); as errorKey) {
            <small class="text-danger">{{ errorKey | translate }}</small>
          }
        </div>
      }
                </div>
              }
            </div>

            <div class="form-section" formGroupName="tilleggsopplysninger">
              <div class="section-title">
                {{ 'norge.soknad.sektion.tilleggsopplysninger' | translate }}
              </div>
              @if (control('tilleggsopplysninger.eventuelleTilleggssopplysningerEllerMerknader').enabled) {
                <div class="form-field mt-3 mb-3">
                  <label for="eventuelleTilleggssopplysningerEllerMerknader">
                    {{ 'norge.soknad.felt.eventuelleTilleggssopplysningerEllerMerknader' | translate }}
                  </label>
                  <textarea id="eventuelleTilleggssopplysningerEllerMerknader" rows="3" class="form-control" formControlName="eventuelleTilleggssopplysningerEllerMerknader"></textarea>
                  @if (fieldErrorKey(control('tilleggsopplysninger.eventuelleTilleggssopplysningerEllerMerknader')); as errorKey) {
                    <small class="text-danger">{{ errorKey | translate }}</small>
                  }
                </div>
              }
            </div>

            <div class="form-section" formGroupName="erklaring">
              <div class="section-title">
                {{ 'norge.soknad.sektion.erklaring' | translate }}
              </div>
              @if (control('erklaring.bekreftelse').enabled) {
                <div class="form-check mt-2 mb-4">
                  <input class="form-check-input" type="checkbox" id="bekreftelse" formControlName="bekreftelse">
                  <label class="form-check-label" for="bekreftelse">
                    {{ 'norge.soknad.felt.erklaring' | translate }}
                  </label>
                </div>
              }
            </div>

            <div class="form-section attachment-section">
              <div class="section-title">
                {{ 'norge.soknad.sektion.vedlegg' | translate }}
              </div>
              <div class="section-subtitle mb-3">{{ 'norge.soknad.felt.annenDokumentasjon' | translate }}</div>
              <file-upload></file-upload>
              @if (attachmentErrorKey; as errorKey) {
                <small class="text-danger">{{ errorKey | translate }}</small>
              }
            </div>

              <div class="form-actions mt-4">
                <button type="button" class="btn-garanti btn-blue" (click)="submit()">
                  {{ 'button.save-and-send' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    </div>
  </div>
</div>
